import _regeneratorRuntime from '/data/wwwroot/dongliyuanlin.com/web/node_modules/babel-runtime/regenerator';
import _asyncToGenerator from '/data/wwwroot/dongliyuanlin.com/web/node_modules/babel-runtime/helpers/asyncToGenerator';
import Vue from 'vue';
import Vuex from 'vuex';
import axios from 'axios';
Vue.use(Vuex);

var store = function store() {
  return new Vuex.Store({
    state: {
      winHeight: 0,
      playing: false,
      flag: true,
      top: '',
      lang: 'cn'
    },
    mutations: {},
    actions: {
      getPageData: function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(context, payload) {
          var lang, _ref2, data;

          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  lang = payload.lang ? payload.lang : context.state.lang;
                  _context.next = 3;
                  return axios.get('http://api.dongliyuanlin.com/?*=["about.about.getList",[' + payload.id + ']]&lang=' + lang);

                case 3:
                  _ref2 = _context.sent;
                  data = _ref2.data;

                  if (!(data.code === 1)) {
                    _context.next = 7;
                    break;
                  }

                  return _context.abrupt('return', data.data);

                case 7:
                case 'end':
                  return _context.stop();
              }
            }
          }, _callee, this);
        }));

        function getPageData(_x, _x2) {
          return _ref.apply(this, arguments);
        }

        return getPageData;
      }(),
      getPageDetail: function () {
        var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(context, payload) {
          var lang, _ref4, data;

          return _regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  lang = payload.lang ? payload.lang : context.state.lang;
                  _context2.next = 3;
                  return axios.get('http://api.dongliyuanlin.com/?*=["about.about.get",[' + payload.id + ']]&lang=' + lang);

                case 3:
                  _ref4 = _context2.sent;
                  data = _ref4.data;

                  if (!(data.code === 1)) {
                    _context2.next = 7;
                    break;
                  }

                  return _context2.abrupt('return', data.data);

                case 7:
                case 'end':
                  return _context2.stop();
              }
            }
          }, _callee2, this);
        }));

        function getPageDetail(_x3, _x4) {
          return _ref3.apply(this, arguments);
        }

        return getPageDetail;
      }(),
      getPageIndex: function () {
        var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(context, payload) {
          var lang, _ref6, data;

          return _regeneratorRuntime.wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  lang = payload.lang ? payload.lang : context.state.lang;
                  _context3.next = 3;
                  return axios.get('http://api.dongliyuanlin.com/?*=["about.about.getIndex",[]]&lang=' + lang);

                case 3:
                  _ref6 = _context3.sent;
                  data = _ref6.data;

                  if (!(data.code === 1)) {
                    _context3.next = 7;
                    break;
                  }

                  return _context3.abrupt('return', data.data);

                case 7:
                case 'end':
                  return _context3.stop();
              }
            }
          }, _callee3, this);
        }));

        function getPageIndex(_x5, _x6) {
          return _ref5.apply(this, arguments);
        }

        return getPageIndex;
      }()
    }
  });
};

export default store;


//////////////////
// WEBPACK FOOTER
// ./store/index.js
// module id = ./store/index.js
// module chunks = 18